import { useState } from "react";

import NewProjectUI from "./NewProjectModal.ui.tsx";

interface UseNewProjectModalProps {
  onStandardProject: () => void;
  onCustomProject: () => void;
}

export const useNewProjectModal = ({
  onStandardProject,
  onCustomProject,
}: UseNewProjectModalProps) => {
  const [show, setShow] = useState(false);

  const open = () => setShow(true);
  const close = () => setShow(false);

  const handleStandardProject = () => {
    close();
    onStandardProject();
  };

  const handleCustomProject = () => {
    close();
    onCustomProject();
  };

  const modal = (
    <NewProjectUI
      show={show}
      handleClose={close}
      onStandardProject={handleStandardProject}
      onCustomProject={handleCustomProject}
    />
  );

  return { show, open, close, modal };
};
